import {
  EuiButton,
  EuiButtonEmpty,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiRadio,
  EuiSelect,
} from '@elastic/eui';
import type { ChangeEvent } from 'react';
import { useContext, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { DEFAULT_DOMICILE_CODE } from '../model';
import { PageContext } from './page_context';

export interface CountrySelectorModalProps {
  onClose: () => void;
}

export function DomicileSelectorModal({ onClose }: CountrySelectorModalProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings, setSettings, parameters, domicileCode } = useContext(PageContext);

  const [selectedDomicile, setSelectedDomicile] = useState<string>(domicileCode);

  const domiciles = useMemo(
    () => parameters.domiciles.map((domicile) => ({ text: domicile.displayName, value: domicile.code })),
    [parameters],
  );

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Change domicile</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiForm id="save-country-selection-form" component="form">
          <EuiFormRow label="Investor type">
            <EuiRadio
              id="investor-type"
              label="Private Investor"
              checked
              disabled
              onChange={() => {
                // noop
              }}
            />
          </EuiFormRow>
          <EuiFormRow label="Country">
            <EuiSelect
              value={selectedDomicile}
              options={domiciles}
              onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                setSelectedDomicile(e.target.value);
              }}
            />
          </EuiFormRow>
        </EuiForm>
      </EuiModalBody>

      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          type="submit"
          form="save-country-selection-form"
          fill
          onClick={() => {
            setSettings({ ...settings, country: selectedDomicile });

            const pathname =
              domicileCode === DEFAULT_DOMICILE_CODE
                ? `/${selectedDomicile}${location.pathname}`
                : selectedDomicile === DEFAULT_DOMICILE_CODE
                  ? location.pathname.slice(domicileCode.length + 1)
                  : location.pathname.replace(`/${domicileCode}`, `/${selectedDomicile}`);
            navigate({ pathname, hash: location.hash, search: location.search }, { replace: true });

            onClose();
          }}
          isDisabled={selectedDomicile === domicileCode}
        >
          Save
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
}
